export default [
    {
        path: 'confirmacao-exame',
        component: () => import(
            /* webpackChunkName: 'exame-imagem-confirmacao-exame' */
            '@/views/exame-imagem/confirmacao-exame/Index'
        ),
        redirect: 'confirmacao-exame/index',
        children: [
            {
                name: 'exame-imagem-confirmacao-exame-index',
                path: 'index',
                component: () => import(
                    /* webpackChunkName: 'exame-imagem-confirmacao-exame' */
                    '@/views/exame-imagem/confirmacao-exame/List.vue'
                ),
            },
        ],
    },
]
